import { render, staticRenderFns } from "./ButtonCheckboxGroup.vue?vue&type=template&id=332a1da4"
import script from "./ButtonCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./ButtonCheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports